import type { PageContext } from '@zto/zpage'
import { commonOptions } from '@/config/options'
import { AccountAffiliation, AccountAffiliationName } from '@/config/enums'

function affiliationLabel(v: unknown) {
  if (v == null) return '--'
  return (AccountAffiliationName as any)[String(v)] || String(v)
}

export function accountColumnAffiliation(row: any) {
  return affiliationLabel(row.belongType)
}

const sharedAccountFields = (isEdit: boolean) => [
  {
    type: 'input',
    prop: 'userName',
    label: '账号名称',
    trim: true,
    maxlength: 10,
    required: true
  },
  {
    type: 'input',
    prop: 'mobile',
    label: '手机号',
    trim: true,
    maxlength: 11,
    required: true,
    rules: [
      {
        pattern: /^1[3-9][0-9]\d{8}$/,
        message: '请填写正确的手机号码'
      }
    ]
  },
  isEdit
    ? {
        type: 'input',
        prop: 'password',
        label: '密码',
        inputType: 'password',
        trim: true,
        placeholder: '不修改请留空',
        maxlength: 50,
        rules: [{ min: 6, message: '密码至少 6 位' }]
      }
    : {
        type: 'input',
        prop: 'password',
        label: '密码',
        inputType: 'password',
        trim: true,
        required: true,
        maxlength: 50,
        rules: [{ min: 6, message: '密码至少 6 位' }]
      },
  {
    type: 'select',
    prop: 'belongType',
    label: '归属',
    options: commonOptions.accountAffiliation,
    required: true,
    onChange: (model: any) => {
      model.roleCode = undefined
      model.roleName = undefined
      model.supplierOrgCode = undefined
      model.supplierOrgName = undefined
    }
  },
  {
    type: 'fuzzy-select',
    prop: 'roleCode',
    labelProp: 'roleName',
    label: '角色',
    api: '/base_user/admin/role/list',
    optionValueProp: 'roleCode',
    optionLabelProp: 'roleName',
    apiParams: {
      current: 1,
      size: 500
    },
    triggerFocus: true,
    remote: true,
    keywordProp: 'roleName',
    required: true,
    placeholder: '请先选择归属',
    dynamicAttrs: ({ data }: PageContext) => ({
      apiParams: { roleType: data.belongType },
      disabled: data.belongType == null
    })
  },
  {
    type: 'fuzzy-select',
    prop: 'supplierOrgCode',
    labelProp: 'supplierOrgName',
    label: '供应商',
    api: '/cabinet/admin/base/AdminBaseSupplierQueryController/queryList',
    apiParams: { current: 1, size: 500 },
    optionValueProp: 'supplierCode',
    optionLabelProp: 'supplierName',
    triggerFocus: true,
    remote: true,
    keywordProp: 'supplierName',
    visibleOn: `this.data.belongType === '${AccountAffiliation.SUPPLIER}'`,
    dynamicAttrs: ({ data }: PageContext) => ({
      required: data.belongType === AccountAffiliation.SUPPLIER
    })
  }
]

/**
 * 账号新增 / 编辑共用弹窗（字段与校验、角色接口参数等与原先两个 dialog 一致）
 */
export function accountDialog(isEdit: boolean) {
  return {
    width: 560,
    labelWidth: 110,
    itemSpan: 24,
    onShow: isEdit
      ? async ({ data }: PageContext) => {
          const row = data?.row || data
          return { payload: { ...row } }
        }
      : async () => ({ payload: { belongType: AccountAffiliation.HEADQUARTERS } }),
    formItems: sharedAccountFields(isEdit),
    beforeSubmit: async (_ctx: PageContext, model: any) => {
      if (isEdit) {
        if (!model.password) {
          delete model.password
        }
      }
      if (model.belongType !== AccountAffiliation.SUPPLIER) {
        model.supplierOrgCode = undefined
        model.supplierOrgName = undefined
      }
      delete model.roleName
      delete model.supplierOrgName
      return true
    },
    actions: { close: {}, submit: { label: isEdit ? '保存' : '确定' } }
  }
}

export function addAccountDialog() {
  return accountDialog(false)
}

export function editAccountDialog() {
  return accountDialog(true)
}
